<template>
  <div class="block-wrap block-specification" style="padding: 10px">
    <div v-for="(s, sindex) in specifications" :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" :rules="skuRules" inline>
        规格名：
        <el-input v-if="s.isSale" :disabled="true" style="width: 140px" v-model="s.name" :maxlength="20"></el-input>
        <el-form-item v-else prop="name">
          <el-select v-model="s.name" width="140px" :loading="selectLoading" @change="changeSelectSpecName($event, s)">
            <el-option
              v-for="op in specOptions"
              :disabled="specifications.some(_s => _s.name === op.parentSpecName)"
              :key="op.parentSpecId"
              :value="op.parentSpecName"
              :label="op.parentSpecName"
            />
          </el-select>
        </el-form-item>
        <el-checkbox style="margin-left: 8px" v-model="s.checked" @change="onChangeSpCheckbox" :disabled="s.required"></el-checkbox>
        <el-button style="float: right" v-if="!s.isSale" type="link" @click="removeSpName(sindex)">删除</el-button>
      </el-form>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
        <vue-draggable
          class="specification-value-flex"
          v-model="specifications[sindex].values"
          handle=".drag-icon-wrap"
          :group="{ name: s.nameKey, pull: 'clone', put: false }"
          :animation="500"
        >
          <div v-for="(v, vi) in specifications[sindex].values" :key="v.valueKey" class="specification-value-flex_item">
            <el-form ref="specFormRef" :key="vi" :model="v">
              <el-form-item prop="value" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                  <template v-if="s.valueUnit">
                    <el-input-digit
                      v-model.number="v.extendValues.specValue.value"
                      :precision="0"
                      style="width: 100px"
                      @change="val => extendValueChange(val, sindex, v, vi)"
                    />
                    <el-select
                      v-model="v.extendValues.specValue.valueUnit"
                      placeholder="请选择"
                      width="60px"
                      @change="val => extendValueUnitChange(val, sindex, v, vi)"
                    >
                      <el-option v-for="unit in s.valueUnit" :key="unit" :label="unit" :value="unit"> </el-option>
                    </el-select>
                  </template>
                  <el-select
                    v-else-if="s.isSale"
                    :value="v.value"
                    @change="val => handleSelect(val, sindex, v, vi)"
                    placeholder="请输入或选择"
                    filterable
                    :allow-create="s.allowCreate"
                    clearable
                    default-first-option
                  >
                    <template v-if="options[v.refPid].find(group => group.options && group.options.length)">
                      <el-option-group v-for="group in options[v.refPid]" :key="group.label" :label="group.label">
                        <el-option
                          v-for="item in group.options"
                          :key="item.vid"
                          :label="item.value"
                          :value="item.value"
                          :disabled="s.values.some(_v => _v.value === item.value)"
                        >
                        </el-option>
                      </el-option-group>
                    </template>
                    <template v-else>
                      <el-option
                        v-for="(op, opidx) in options[v.refPid]"
                        :key="`${sindex}-${vi}-${opidx}`"
                        :label="op.value"
                        :value="op.value"
                        :disabled="s.values.some(_v => _v.value === op.value)"
                      ></el-option>
                    </template>
                  </el-select>
                  <el-input
                    v-else
                    v-model="v.value"
                    placeholder="请输入"
                    class="specification-value-flex_input"
                    @keyup.enter.native="e => valueEnter(sindex, vi)"
                    @input="e => valueInput(e, s)"
                  ></el-input>
                  <el-checkbox
                    style="margin-left: 8px; vertical-align: middle"
                    v-model="v.checked"
                    @change="onChangeCheckbox"
                    :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"
                  >
                  </el-checkbox>
                  <div @click="removeSpValue(sindex, vi, v)" class="del-btn"><i class="el-icon-close" /></div>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
              <el-form-item prop="note" v-if="s.canNote" :rules="genFormItemRemarkRule(v)">
                <div class="remarkWrap">
                  <el-input
                    class="input-remark"
                    :ref="`${sindex}-${vi}-remark`"
                    placeholder="备注"
                    @change="remarkInput"
                    v-model="v.note"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item v-if="s.showImg" prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                <div class="specification-value-flex_img">
                  <ImgUpload
                    :ref="`${sindex}-${vi}-img`"
                    :width="80"
                    :height="80"
                    :file="v.imageUrl"
                    :autoCropImageParams="skuCropImageParams"
                    @upload-success="url => imageUploadSuccess(url, v, vi)"
                    @del="() => imageUploadDel(v)"
                    :isSingle="true"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="specification-value-flex_item drag-ignore_item">
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
      </div>
      <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color: #ccc">
        <span
          >默认取商品第一张主图，买家选择不同规格会看到对应规格图片，长宽比仅支持 1:1 且长宽尺寸需大于 800px，建议尺寸: 800 x 800
          像索，建议格式:png，jpg，jpeg格式</span
        >
      </div>
    </div>
    <div v-if="showAddSpNameBtn" class="title-bg">
      <el-button @click="handleAddSpName">添加商品规格</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import { dragItemMixin } from '../../../utils/mixins';
import genkey from '@/utils/genkey.js';

import { cloneDeep } from 'lodash';

export default {
  components: {
    ImgUpload,
  },
  model: {
    prop: 'values',
    event: 'change',
  },
  mixins: [dragItemMixin],
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    imgLimits: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sizeType: {
      // 规格类型
      type: Number,
      default: 1,
    },
    specOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    saleProps: {
      type: Array,
      default() {
        return [];
      },
    },
    customSpecNum: Number,
    skuCropImageParams:{
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      specifications: [],
      selectLoading: false, // 规格名下拉框loading
      options: {},
      isDefault: true,
    };
  },
  computed: {
    skuRules({ specOptions }) {
      return {
        name: [
          {
            validator: (_, value, callback) => {
              if (~specOptions.findIndex(s => s.parentSpecName === value)) {
                callback();
              } else {
                callback(new Error('规格名不存在，重新选择'));
              }
            },
            trigger: 'change',
          },
        ],
      };
    },
    showAddSpNameBtn() {
      return this.customSpecNum > this.specifications.filter(s => !s.isSale).length;
    },
  },
  watch: {
    values: {
      handler(v) {
        this.specifications = v;
        this.$nextTick(() => {
          // this.validateSpecForm()
        });
      },
      immediate: true,
      deep: true,
    },
    sizeType: {
      handler() {
        this.computeOptions();
        this.computeSpec();
      },
      // immediate: true,
    },
    saleProps: {
      handler() {
        this.computeOptions();
        this.computeSpec();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.computeOptions();
    // this.computeSpec();
  },
  methods: {
    computeOptions() {
      const res = {};
      this.saleProps.forEach((item, idx) => {
        if (!item) return;
        if (item.name === '尺码') {
          let hasGroup = false;
          let values = item.values || [];
          if (values.length) {
            hasGroup = !!values[0].group;
          }
          if (hasGroup) {
            values = (item.values || []).filter(v => String(v.group.id) === String(this.sizeType));
          }
          res[item.refPid] = this.groupSpec((values || []).slice(0));
        } else {
          res[item.refPid] = this.groupSpec((item.values || []).slice(0));
        }
      });
      this.options = res;
    },
    // 尺码-spcId初始和下拉框列表匹配
    computeSpec() {
      for (let [idx, spec] of this.specifications.entries()) {
        spec.values.forEach(v => {
          let item = this.getItemByOptins(v.value, v.refPid);
          if (item) {
            v.extendValues.specId = item.specId;
            v.vid = item.vid;
            v.groupId = item.group && item.group.id;
          }
        });
      }
    },
    // 颜色信息分组
    groupSpec(values) {
      const groups = values.reduce((acc, v) => {
        if (v.group) {
          if (!acc[v.group.name]) acc[v.group.name] = [];
          acc[v.group.name].push(v);
        } else {
          if (!acc['其他']) acc['其他'] = [];
          acc['其他'].push(v);
        }
        return acc;
      }, {});
      const options = [];
      for (let key in groups) {
        options.push({
          label: key,
          options: groups[key],
        });
      }
      return options;
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => result);
            if (!allValid) {
              resolve(allValid);
            }
            resolve(true);
          })
          .catch(() => {
            console.log('validateSpecForm has Error');
            resolve(false);
          });
      });
    },
    genFormItemValueRule(specItem, v, vi) {
      let valueValidator = (rule, value, callback) => {
        let options = this.options[v.refPid];
        if (!specItem.allowCreate && specItem.isSale && value && options?.length) {
          const findItem = this.getItemByOptins(value, v.refPid);
          if (!findItem) {
            return callback(new Error('规格值匹配失败，请重新选择'));
          }
        }
        if (value) {
          const findItem = specItem.values.find((item, i) => item.value === value && i !== vi);
          if (findItem) {
            return callback(new Error('请勿输入相同规格值'));
          }
        }
        callback();
      };
      return [{ required: true, message: '规格值必填' }, { validator: valueValidator }];
    },
    genFormItemRemarkRule(v) {
      // 规格值 + 备注长度校验
      let valueValidator = (rule, value, callback) => {
        const totallen = ((v.value || '') + (v.note || '')).length;
        if (totallen > 22) {
          return callback(new Error('规格值+备注不超过22个字'));
        }
        callback();
      };
      return [{ validator: valueValidator }];
    },
    genFormItemImgRule(valueItem, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        const refImg = this.$refs[ref];
        if (valueItem.imageUrl && refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage();
          if (errMsg) {
            return callback(new Error(errMsg));
          } else {
            callback();
          }
        }
        if(!valueItem.imageUrl){
          return callback(new Error('请上传规格图'));
        }
        callback();
      };
      return [
        {
          required: true,
          validator: valueValidator,
        },
      ];
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
    },
    remarkInput() {
      window.__spcificationCheckbox_changed = true;
      // this.$emit('fieldChanged');
    },
    async changeSelectSpecName(val, s) {
      const findSpec = this.specOptions.find(opts => opts.parentSpecName === val);
      if (findSpec) {
        s.extendValues.parentSpecId = findSpec.parentSpecId;
        s.nameKey = s.nameKey || val;
      }
      window.__spcificationCheckbox_changed = true;
      // this.$emit('fieldChanged');
      this.$emit('change', this.specifications);
    },
    onChangeSpCheckbox() {
      window.__spcificationSpCheckbox_changed = true;
      this.$emit('change', this.specifications);
    },
    // 添加规格名
    handleAddSpName() {
      const specifications = cloneDeep(this.specifications);
      const spec = {
        checked: true,
        extendValues: {
          parentSpecId: '',
          isSkc: false,
        },
        name: '',
        nameKey: '',
        isSale: false,
        values: [
          // {
          //   checked: true,
          //   value: '无规格',
          //   valueKey: genkey.get('v'),
          //   refPid: '',
          //   vid: '',
          //   extendValues: {
          //     parentSpecId:  '',
          //     specId: '',
          //   },
          // }
        ],
      };
      specifications.push(spec);
      this.$emit('change', specifications);
    },
    // 移除规格名
    removeSpName(index) {
      this.specifications.splice(index, 1);
      this.$emit('change', this.specifications);
    },
    defaultProduct_skc() {
      return {
        extCode: '',
        previewImgUrls: [],
      };
    },
    // 添加规格值
    addSpValue(index) {
      const { values, valueUnit, refPid } = this.specifications[index];
      const voidValue = {
        ...values[0],
        checked: true,
        refPid,
        value: '',
        valueKey: genkey.get('v'),
        groupId: '',
        extendValues: {
          ...values[0]?.extendValues,
          specId: '',
          product_skc: {
            extCode: '',
            previewImgUrls: [],
          },
        },
        vid: '',
        note: '',
        imageUrl: '',
      };
      if (valueUnit && !voidValue.extendValues?.specValue) {
        voidValue.extendValues = voidValue.extendValues || {};
        voidValue.extendValues.specValue = { value: '', valueUnit: '' };
      }
      this.specifications[index].values.push(voidValue);
      window.__spcificationImg_changed = voidValue.valueKey; // 用于skuList生成时的图片取值规则
      // this.$emit('fieldChanged');
      this.$emit('change', this.specifications);
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      this.specifications[sindex].values.splice(index, 1);
      window.__spcificationImg_changed = v.valueKey;
      // this.fieldChanged();
      this.$emit('change', this.specifications);
    },
    querySearch(v, str, cb) {
      cb(this.options[v.refPid] || []);
    },
    getItemByOptins(val, refPid) {
      let item = null;
      let options = this.options[refPid] || [];
      if (options && options[0] && options[0].options) {
        options = options.reduce((acc, op) => {
          acc = acc.concat(op.options);
          return acc;
        }, []);
      }
      const idx = options.findIndex(it => it.value === val);
      if (idx !== -1) {
        item = options[idx];
      }
      return item;
    },
    async handleSelect(val, sindex, v, vi) {
      let item = this.getItemByOptins(val, v.refPid) || {};
      let value = {
        ...v,
        value: val,
        vid: item.vid || '',
        groupId: (item.group && item.group.id) || '',
      };
      value.extendValues.specId = item.specId || '';
      this.$set(this.specifications[sindex].values, vi, value);
      this.$emit('change', this.specifications);
    },
    isSame(values, value, idx) {
      let flag = false;
      values.forEach((item, i) => {
        if (i !== idx && item.value === value) {
          flag = true;
        }
      });
      return flag;
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    async valueInput(val, s) {
      window.__spcificationImg_changed = true;
      // this.$emit('change', specifications);
    },
    async imageUploadSuccess(url, v, vi) {
      v.imageUrl = url;
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
    },
    imageUploadDel(v) {
      this.isDefault = false;
      v.imageUrl = '';
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
    },
    async validate() {
      const specificationValid = await this.validateSpecForm();
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    hasValueUnit(v) {
      return v.extendValues?.specValue?.valueUnit;
    },
    async extendValueChange(val, sindex, v, vi) {
      const value = val + v.extendValues.specValue.valueUnit;
      this.specifications[sindex].values[vi].value = value;
      this.specifications[sindex].values[vi].extendValues.specValue.value = val;
      this.$emit('change', this.specifications);
    },
    async extendValueUnitChange(valUnit, sindex, v, vi) {
      const value = v.extendValues.specValue.value + valUnit;
      this.specifications[sindex].values[vi].value = value;
      this.specifications[sindex].values[vi].extendValues.specValue.valueUnit = valUnit;
      this.$emit('change', this.specifications);
    },
  },
};
</script>

<style lang="scss" scoped>
.specification-value-flex_input {
  margin-bottom: 10px;
}
.block-wrap {
  border: 1px solid #dcdfe6;

  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  // ::v-deep .el-input input {
  //   background: #F8F8F8 !important;
  // }
}

.specification-value {
  display: flex;
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    position: relative;
    margin-top: 10px;

    // top: -16px;
    &_item {
      margin-right: 10px;
      margin-bottom: 15px;
    }
    &_img {
      width: 100%;
      margin-top: 10px;
      position: relative;
    }
    .el-input,
    .el-select {
      width: 160px;
    }
  }
  ::v-deep .el-form-item__error {
    position: relative;
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>